// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__30ESF","ranges":"BmiRanges_ranges__26-uS"};